export default "__VITE_ASSET__ClgjkrsV__"